import React, {useEffect, useRef, useState} from 'react';
import CardHeader from '../../components/common/card-header/CardHeader';
import {Card, FlexItem, FlexLayout, Spinner, StackLayout, Text} from '@salt-ds/core';
import ForgotUserOrOrgIdCardForm from './ForgotUserOrOrgIdCardForm';
import Constants from '../../components/common/Constants';
import '../CommonCard.css';
import {useIntl} from 'react-intl';
import CardAlert from "../../components/common/card-alert/CardAlert";
import {customerServiceLink} from '../../common/ApiUtils';
import {useLocation, useNavigate} from "react-router";


function ForgotUserOrOrgIdCard() {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const mainRef = useRef(null);

  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.forgot.userid.orgid.card.step.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    if (location.state?.from !== '/forgotUserOrOrgIdEmail' && sessionStorage.getItem("previousPage") !== '/forgotUserOrOrgIdEmail') {
      navigate('/');
    }
  }, [intl,navigate,location]);

  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const showErrorOnPage = (error) => {
    setErrorMessage(error);
    setHasError(true);
  }

  return (
    <main ref={mainRef} role="main" aria-label="Forgot User or Org ID Card" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        {isLoading ? (
            <FlexItem className="spinner-wrapper">
              <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
            </FlexItem>
        ) : (
            <FlexItem className={`error-wrapper ${hasError ? 'visible' : ''}`}>
              <div>
                <CardAlert status={"error"} setHasError={setHasError}>{errorMessage}</CardAlert>
              </div>
            </FlexItem>
        )}
        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <StackLayout gap={1.5}>
                <CardHeader heading={Constants.forgotUserOrOrgIdTitle} subheading={Constants.forgotUserOrOrgIdCommercialCardStep}
                            style={{maxWidth: "28rem"}} />
                <FlexItem>
                  <Text>
                    {Constants.forgotUserOrOrgIdCommercialCardStepInstructionalText(customerServiceLink)}
                  </Text>
                </FlexItem>
                <ForgotUserOrOrgIdCardForm showErrorOnPage={showErrorOnPage} isLoading={isLoading} setIsLoading={setIsLoading} setHasError={setHasError}/>
              </StackLayout>
            </FlexItem>
          </Card>
        </FlexItem>
      </FlexLayout>
    </main>
  );
}

export default ForgotUserOrOrgIdCard;